import React from "react";
import './FormattedDate.css';

export default function FormattedDate(props) {
    let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]

    let day = days[props.date.getDay()];
    let hour = props.date.getHours();
    let mins = props.date.getMinutes();

    if (mins < 10) {
        mins = `0${mins}`
    }

    return (
        <div className="FormattedDate">
           <h5>{day} {hour}:{mins}</h5>
        </div>
        
    )
}